import React from 'react'
import { useCart, CartProps } from './useCart'
import { Link } from 'react-router-dom'
import Layout from 'components/Layout/Layout'
import CartItems from './CartItems/CartItems'
import styles from './Cart.module.scss'

const Cart: React.FC<CartProps> = (props: CartProps) => {
  const { restaurantName, currency, customerCart } = useCart(props)

  return (
    <Layout>
      <main>
        <div className={styles.head_container}>
          <h1 className={styles.title}>
            <Link to={`/${restaurantName}`} className={styles.link}>
              <i className='bi bi-arrow-left-circle me-2'></i>
            </Link>
            Cart
          </h1>
        </div>
        <CartItems
          restaurantName={restaurantName}
          restaurantCurrency={currency}
          cartData={customerCart}
        />
      </main>
    </Layout>
  )
}

export default Cart
